import {basicSetup, EditorView} from "codemirror";
import Parsers from "../parsers/Parsers";
import Dataset from "../Dataset";
import CurrencyService from "../fx/CurrencyService.js";
import * as DomBuilder from "./dom-builder.js";

/**
 *
 * @version 2026-09-02
 * @author Patrik Harag
 */
export default class ComponentDatasetForm {

    /** @type {HTMLElement} */
    #inputFieldName;
    /** @type {EditorView} */
    #inputEditor;
    /** @type {HTMLElement} */
    #inputTypeSelect;
    /** @type {HTMLElement} */
    #inputCurrencySelect;

    createNode() {
        this.#inputEditor = new EditorView({
            extensions: [basicSetup],
        })

        this.#inputFieldName = DomBuilder.element('input', { class: 'form-control', id: 'dataFieldName' });

        this.#inputTypeSelect = DomBuilder.element('select', { class: 'form-control', id: 'dataTypeSelect' });
        for (let [key, parser] of Parsers.AVAILABLE) {
            this.#inputTypeSelect.append(DomBuilder.element('option', { value: key }, parser.getDisplayName()));
        }

        this.#inputCurrencySelect = DomBuilder.element('select', { class: 'form-control', id: 'dataCurrencySelect' });
        for (let currency of CurrencyService.getSupportedCurrencies()) {
            let attrs = { value: currency };
            if (currency === CurrencyService.getDefaultCurrency()) {
                attrs.selected = true;
            }
            this.#inputCurrencySelect.append(DomBuilder.element('option', attrs, currency));
        }

        return DomBuilder.div({ class: 'dataset-form' }, [
            DomBuilder.div({ class: 'mb-3' }, [
                DomBuilder.element('label', { class: 'form-label', for: 'dataFieldName' }, 'Dataset name'),
                this.#inputFieldName
            ]),
            DomBuilder.div({ class: 'mb-3' }, [
                DomBuilder.element('label', { class: 'form-label' }, 'Data'),
                this.#inputEditor.dom
            ]),
            DomBuilder.div({ class: 'mb-3' }, [
                DomBuilder.element('label', { class: 'form-label', for: 'dataTypeSelect' }, 'Data type'),
                this.#inputTypeSelect
            ]),
            DomBuilder.div({ class: 'mb-3' }, [
                DomBuilder.element('label', { class: 'form-label', for: 'dataCurrencySelect' }, 'Currency'),
                this.#inputCurrencySelect
            ])
        ]);
    }

    getDataset() {
        let name = this.#inputFieldName.value.trim();
        if (!name) {
            name = '' + new Date().getTime();
        }

        let data = this.getRawData();
        let dataType = this.#inputTypeSelect.value;
        let currency = this.#inputCurrencySelect.value;

        return new Dataset(name, dataType, data, currency);
    }

    setRawData(name, data, parserKey, currency) {
        this.#inputFieldName.value = name;
        this.#inputTypeSelect.value = parserKey;
        if (currency) {
            this.#inputCurrencySelect.value = currency;
        }
        this.#inputEditor.dispatch({
            changes: {from: 0, to: this.#inputEditor.state.doc.length, insert: data}
        });
    }

    getRawData() {
        return this.#inputEditor.state.doc.toString();
    }
}
